import React from 'react';
import PropTypes from 'prop-types';

import { CenteredContainer, Box, Title, Text } from '@nerdwallet/currency';

import Image from '@nerdwallet/react-image';
import TypeModule from './type-module/type-module';
import TypeModuleText from '~/client/lib/employee-branding/type-module-text';

import styles from './mission.module.less';

const CompanyMission = ({
  title,
  typeModuleIntro,
  intro,
  body,
  splashImage,
}) => (
  <div>
    <div className={styles.missionContainer}>
      <CenteredContainer className={styles.missionCenteredContainer}>
        <Box className={styles.missionSplashContainer}>
          <Box className={styles.missionSplashOuter}>
            <Box
              className={styles.missionSplash}
              backgroundColor="white"
              shadow="2"
              borderRadius="2"
            >
              <Box className={styles.typeModule}>
                <Title component="h1">{typeModuleIntro}</Title>
                <Title>
                  <TypeModule phraseLibrary={TypeModuleText} />
                </Title>
              </Box>
              <div className={styles.typeIntro}>
                <Text size="default">{intro}</Text>
              </div>
            </Box>
          </Box>
        </Box>
        <Box className={styles.splashImageOuter} borderRadius="2">
          <Box
            className={styles.splashImageContainer}
            borderRadius="2"
            shadow="2"
          >
            <Image
              naturalHeight={579}
              naturalWidth={1030}
              src={splashImage}
              className={styles.splashImage}
              backgroundColor="none"
              alt=""
              lazy
            />
          </Box>
        </Box>
      </CenteredContainer>
    </div>
    <div className={styles.missionCopyContainer}>
      <CenteredContainer>
        <Box className={styles.missionCopy}>
          <Title
            size="small"
            className={styles.missionCopyTitle}
            component="h2"
          >
            {title}
          </Title>
          <Text>{body}</Text>
        </Box>
      </CenteredContainer>
    </div>
  </div>
);

CompanyMission.propTypes = {
  title: PropTypes.string,
  typeModuleIntro: PropTypes.string,
  intro: PropTypes.string,
  body: PropTypes.string,
  splashImage: PropTypes.string,
};

CompanyMission.displayName = 'Company Mission';

export default CompanyMission;
